(() => {
  const ENDPOINT = 'https://zigcryrgwecctnowfosb.supabase.co/functions/v1/track-cod-funnel';
  const SESSION_KEY = 'loubna_cod_funnel_session_v1';
  const SENT_PREFIX = 'loubna_cod_funnel_sent_v1:';
  const SOURCE = 'storefront';
  const nativeFetch = window.fetch.bind(window);

  const uuid = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (b) =>
      b.toString(16).padStart(2, '0')
    );

    return `${hex.slice(0, 4).join('')}-${hex
      .slice(4, 6)
      .join('')}-${hex.slice(6, 8).join('')}-${hex
      .slice(8, 10)
      .join('')}-${hex.slice(10, 16).join('')}`;
  };

  const getSessionId = () => {
    try {
      const existing = sessionStorage.getItem(SESSION_KEY);

      if (existing && /^[0-9a-f-]{36}$/i.test(existing)) {
        return existing;
      }

      const created = uuid();
      sessionStorage.setItem(SESSION_KEY, created);
      return created;
    } catch (_) {
      return uuid();
    }
  };

  const sessionId = getSessionId();

  const cleanReferrer = (value) => {
    if (!value) return '';

    try {
      const u = new URL(value);
      return `${u.origin}${u.pathname}`;
    } catch (_) {
      return '';
    }
  };

  const currentAttribution = () => {
    try {
      return window.LoubnaTracking?.get?.() || null;
    } catch (_) {
      return null;
    }
  };

  const sentAlready = (key) => {
    if (!key) return false;

    try {
      return sessionStorage.getItem(`${SENT_PREFIX}${key}`) === '1';
    } catch (_) {
      return false;
    }
  };

  const markSent = (key) => {
    if (!key) return;

    try {
      sessionStorage.setItem(`${SENT_PREFIX}${key}`, '1');
    } catch (_) {}
  };

  const track = (
    eventName,
    properties = {},
    requestId = null,
    dedupeKey = null
  ) => {
    if (dedupeKey && sentAlready(dedupeKey)) return;

    if (dedupeKey) {
      markSent(dedupeKey);
    }

    const payload = {
      event_id: uuid(),
      session_id: sessionId,
      event_name: eventName,
      client_at: new Date().toISOString(),
      path: window.location.pathname,
      referrer: cleanReferrer(document.referrer),
      request_id: requestId || null,
      marketing_attribution: currentAttribution(),
      properties,
      source: SOURCE,
    };

    nativeFetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  };

  window.LoubnaCodFunnel = {
    track,
    sessionId,
  };

  track('session_started', {}, null, 'session_started');

  if (/\/cart\/?$/.test(window.location.pathname)) {
    track('cart_viewed', {}, null, 'cart_viewed');
  }

  const urlOf = (input) =>
    typeof input === 'string' ? input : input?.url || '';

  const methodOf = (input, init) =>
    String(
      init?.method ||
        (typeof input !== 'string' ? input?.method : '') ||
        'GET'
    ).toUpperCase();

  const parseBody = (input, init) => {
    if (init && typeof init.body === 'string') {
      try {
        return JSON.parse(init.body);
      } catch (_) {
        return null;
      }
    }

    return null;
  };

  window.fetch = async function codFunnelFetch(input, init) {
    const url = urlOf(input);
    const method = methodOf(input, init);

    const isCartAdd =
      method === 'POST' &&
      /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);

    const isCodOrder =
      method === 'POST' &&
      url.includes('/functions/v1/create-order');

    const body = isCodOrder ? parseBody(input, init) : null;
    const requestId = body?.request_id || null;

    if (isCodOrder && requestId) {
      track(
        'cod_form_submitted',
        {
          value:
            body?.grand_total ??
            body?.total_price ??
            null,
          currency: 'DZD',
          total_quantity: body?.total_quantity ?? null,
          delivery_mode: body?.delivery_mode ?? null,
        },
        requestId,
        `cod_form_submitted:${requestId}`
      );
    }

    const response = await nativeFetch(input, init);

    if (isCartAdd && response.ok) {
      response
        .clone()
        .json()
        .then((data) => {
          const quantity = Number(
            data?.quantity ||
              data?.items?.[0]?.quantity ||
              1
          );

          const variantId =
            data?.variant_id ||
            data?.id ||
            data?.items?.[0]?.variant_id ||
            null;

          track('add_to_cart', {
            quantity: Number.isFinite(quantity)
              ? quantity
              : 1,
            variant_id: variantId
              ? String(variantId)
              : null,
          });
        })
        .catch(() => {
          track('add_to_cart', {});
        });
    }

    if (isCodOrder && response.ok && requestId) {
      response
        .clone()
        .json()
        .then((data) => {
          const totals = data?.totals || {};

          track(
            'cod_order_created',
            {
              order_id: data?.order_id || null,
              value:
                totals?.grand_total ??
                body?.grand_total ??
                body?.total_price ??
                null,
              currency: 'DZD',
              total_quantity:
                body?.total_quantity ?? null,
              delivery_mode:
                body?.delivery_mode ?? null,
            },
            requestId,
            `cod_order_created:${requestId}`
          );
        })
        .catch(() => {});
    }

    return response;
  };

  const bindCodFormStart = () => {
    const form = document.querySelector(
      'cod-cart-checkout .cod-cart-checkout__domestic form'
    );

    if (
      !form ||
      form.dataset.codFunnelBound === '1'
    ) {
      return;
    }

    form.dataset.codFunnelBound = '1';

    const once = () => {
      track(
        'cod_form_started',
        {},
        null,
        'cod_form_started'
      );

      form.removeEventListener('focusin', once);
      form.removeEventListener('input', once);
      form.removeEventListener('change', once);
      form.removeEventListener('pointerdown', once);
    };

    form.addEventListener('focusin', once);
    form.addEventListener('input', once);
    form.addEventListener('change', once);
    form.addEventListener('pointerdown', once);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      bindCodFormStart,
      { once: true }
    );
  } else {
    bindCodFormStart();
  }
})();